import { IconProps } from '../../Icon.types';

export const Absence3DIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="4 4 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(12)"
    >
      <g clipPath="url(#clip0_11921_7074)">
        <g filter="url(#filter0_i_11921_7074)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1712 9.20889C16.1436 9.0022 17.0994 9.62293 17.3061 10.5953L17.4342 11.198C18.3534 10.9861 19.3795 10.768 20.5235 10.5248L28.4235 8.84564C29.5676 8.60246 30.5937 8.38434 31.5195 8.20404L31.3914 7.60139C31.1847 6.629 31.8055 5.67317 32.7779 5.46648C33.7502 5.25979 34.7061 5.88052 34.9128 6.8529L35.0903 7.68796C36.1277 7.62586 37.0909 7.68506 38.0375 7.9387C40.1181 8.4962 41.9689 9.69808 43.3244 11.3721C44.1681 12.4139 44.692 13.6321 45.1272 15.0854C45.5515 16.5024 45.931 18.2878 46.4062 20.5237L48.0855 28.4238C48.5607 30.6597 48.9402 32.4451 49.1289 33.9122C49.3225 35.4169 49.3394 36.7428 48.9924 38.0377C48.4349 40.1184 47.233 41.9691 45.559 43.3247C44.5172 44.1683 43.299 44.6922 41.8457 45.1274C40.4287 45.5518 38.6433 45.9313 36.4074 46.4065L28.5073 48.0857C26.2714 48.561 24.486 48.9405 23.0189 49.1292C21.5142 49.3227 20.1883 49.3396 18.8933 48.9926C16.8127 48.4351 14.962 47.2333 13.6064 45.5593C12.7627 44.5174 12.2389 43.2992 11.8037 41.8459C11.3793 40.4289 10.9998 38.6435 10.5246 36.4076L8.84538 28.5076C8.37011 26.2716 7.99059 24.4862 7.8019 23.0192C7.60837 21.5145 7.59147 20.1885 7.93844 18.8936C8.49595 16.813 9.69783 14.9622 11.3718 13.6067C12.1334 12.9899 12.9892 12.5441 13.9623 12.1789L13.7848 11.3438C13.5781 10.3714 14.1988 9.41558 15.1712 9.20889ZM14.7227 15.7562C14.268 15.9607 13.9243 16.1721 13.6374 16.4044C12.5542 17.2815 11.7765 18.4791 11.4158 19.8253C11.2408 20.4784 11.2075 21.2768 11.3725 22.5599C11.4507 23.1678 11.5679 23.8492 11.721 24.6394L42.2059 18.1597C42.0243 17.3755 41.8543 16.7053 41.6785 16.1182C41.3074 14.8788 40.9522 14.163 40.5267 13.6376C39.6496 12.5545 38.452 11.7768 37.1057 11.416C36.7491 11.3205 36.3492 11.2672 35.8507 11.2653L35.9107 11.548C36.1174 12.5204 35.4967 13.4762 34.5243 13.6829C33.5519 13.8896 32.5961 13.2689 32.3894 12.2965L32.2681 11.7259C31.3686 11.9005 30.3284 12.1212 29.0955 12.3832L21.3485 14.0299C20.1156 14.292 19.0755 14.5134 18.1828 14.7198L18.3041 15.2904C18.5108 16.2628 17.89 17.2186 16.9177 17.4253C15.9453 17.632 14.9894 17.0113 14.7827 16.0389L14.7227 15.7562ZM42.9711 21.6774L12.4528 28.1643L14.0296 35.5826C14.5249 37.9124 14.8752 39.5537 15.2523 40.8132C15.6235 42.0525 15.9787 42.7683 16.4041 43.2937C17.2813 44.3769 18.4788 45.1546 19.8251 45.5153C20.4781 45.6903 21.2765 45.7236 22.5597 45.5586C23.8637 45.3909 25.5055 45.0433 27.8354 44.5481L35.5823 42.9014C37.9122 42.4062 39.5534 42.0559 40.8129 41.6788C42.0522 41.3076 42.7681 40.9524 43.2935 40.527C44.3766 39.6498 45.1543 38.4523 45.5151 37.106C45.69 36.453 45.7234 35.6546 45.5584 34.3714C45.3906 33.0674 45.0431 31.4256 44.5479 29.0957L42.9711 21.6774Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_11921_7074"
          x="6.66492"
          y="5.42676"
          width="42.601"
          height="44.8394"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_11921_7074"
          />
        </filter>
        <clipPath id="clip0_11921_7074">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0 9.97998) rotate(-12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
